import React, { useRef, useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import { ReactComponent as CloseModalIcon } from '../../assets/svg/CloseModalIcon.svg';
import { ReactComponent as UploadDataIcon } from '../../assets/svg/UploadDataIcon.svg';
import { ReactComponent as ExitCross } from '../../assets/svg/ExitCross.svg';
import { ReactComponent as TargetUndo } from '../../assets/svg/undoTarget.svg';
import '../../styles/modals/StudentInfoModal.css';
import Loading from '../Loading';
import { useNavigate } from 'react-router-dom';
import { downloadCourses, uploadExelFile } from '../../server/server';
import { baseUrl, fileSystemUrl } from '../../server/connections';
import { notify } from '../../utils/util';

function ManageLanguageModal({ modalIsOpen, closeModal }: { modalIsOpen: any; closeModal: any }) {
	const [processing, setProcessing] = useState(false);
	const navigate = useNavigate();
	const [mode, setMode] = useState('list');
	const [courses, setCourses] = useState([]);
	const [allCourses, setAllCourses] = useState<any>([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (modalIsOpen) {
			loadCourses();
		}
	}, [modalIsOpen]);

	const loadCourses = async () => {
		// const resp = await getLocales();
		// if (resp.status === 200) {
		// 	setCourses(resp.data);
		//     setLoading(false)
		// }else{
		//     setLoading(false)
		// }
	};

	const cleanUpFunction = () => {
		setMode('list');
		setProcessing(false);
	};

	const openCourse = (course: any) => {
		// navigate(`/courses/${course.id}`);
	};

	const importCourses = async () => {
		setProcessing(true);
		fetch(`${baseUrl}/admin/translation/download-excel`)
			.then((response) => {
				if (!response.ok) {
					setProcessing(false);
					throw new Error('Network response was not ok');
				}
				return response.blob();
			})
			.then((blob) => {
				setProcessing(false);
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.href = url;
				a.download = 'excel-file.xlsx';
				document.body.appendChild(a);
				a.click();
				window.URL.revokeObjectURL(url);
				closeModal();
			})
			.catch((error) => {
				console.error('Error downloading file:', error);
				setProcessing(false);
			});
	};

	const CourseButton = (course: any) => {
		return (
			<div
				className='my-[5px] flex cursor-pointer flex-row gap-5 rounded-[10px] border border-[#F8F8FB] bg-[#F8F8FB] px-[40px] py-[25px] duration-300 ease-out hover:border-mudPurple'
				onClick={() => {
					openCourse(course);
				}}
				key={course.id}
			>
				{!!course.headlineImage && (
					<div className='w-full max-w-[160px] '>
						<img style={{ objectFit: 'contain', width: '100%', minHeight: 120, maxHeight: 120 }} src={fileSystemUrl + '/' + course.headlineImage?.url} alt='' />
					</div>
				)}
				<div className='flex-1'>
					<p className='text-[20px] font-semibold text-primaryViolet'>Title: {course.title}</p>
					<p className='two-lines-of-text mt-[10px] text-[14px] font-medium text-mudPurple'>Subtitle: {course.subtitle}</p>
					<p className='two-lines-of-text mt-[10px] text-[14px] font-medium text-mudPurple'>Challange Title: {course.challangeTitle}</p>
				</div>
				<div className='w-[300px]'>
					<div className='flex flex-row items-center '>
						<p className='text-left text-primaryViolet text-[18px] leading-6 font-semibold'>Locale:&nbsp; </p>
						<p className='text-left text-primaryViolet text-[18px] leading-6 font-semibold ellipsis'>{course?.locale?.name}</p>
					</div>
					<div className='flex flex-row items-center '>
						<p className='text-left text-primaryViolet text-[18px] leading-6 font-semibold text-nowrap'>Category:&nbsp; </p>
						<p className='text-left text-primaryViolet text-[18px] leading-6 font-semibold ellipsis'>{course?.mainCategory?.name}</p>
					</div>
				</div>
			</div>
		);
	};

	return (
		<ReactModal
			isOpen={modalIsOpen}
			onAfterOpen={() => {}}
			onAfterClose={() => cleanUpFunction()}
			onRequestClose={closeModal}
			style={{
				overlay: {
					zIndex: 7,
					background: '#00000045',
				},
				content: {
					padding: 0,
					paddingTop: 30,
					paddingBottom: 30,
					opacity: 1,
					width: 900,
					margin: 'auto',
					backgroundColor: 'transparent',
					maxHeight: '100vh',
					border: 'none',
					boxShadow: 'none',
					overflow: 'auto',
				},
			}}
			className={'scrollbar-display-none'}
		>
			<div className='student-info-modal  '>
				<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
					<div className='close-modal-icon transition' onClick={() => closeModal()}>
						<CloseModalIcon />
					</div>
				</div>
				{mode === 'list' && (
					<div className='bg-white min-h-[426px] rounded-xl mx-3 flex-1 flex flex-col gap-5 px-[40px] py-[30px]'>
						<div className='flex flex-row items-center justify-end gap-4'>
							<div className='flex-1'>
								<p className='text-primaryViolet font-semibold text-3xl text-left'>Manage language</p>
							</div>
							<button
								className={`cursor-pointer flex h-[50px]  min-w-[180px] px-3 items-center justify-center rounded-full 
								bg-primaryViolet text-[18px] leading-6  font-semibold text-white transition  hover:bg-brandYellow hover:text-primaryViolet`}
								onClick={() => setMode('input')}
							>
								Export
							</button>
							<button
								className={`cursor-pointer flex h-[50px]  min-w-[180px] px-3 items-center justify-center rounded-full border border-primaryViolet
									bg-primaryViolet text-[18px] leading-6  font-semibold text-white transition  hover:bg-brandYellow hover:text-primaryViolet`}
								onClick={() => importCourses()}
								disabled={processing}
							>
								Import
							</button>
						</div>
						{loading && (
							<div className='flex w-full flex-grow items-center justify-center'>
								<Loading size={70} primaryColor='#5E639B' stroke={3} />
							</div>
						)}
						{courses.length === 0 && !loading && (
							<div className='flex w-full flex-grow  items-center justify-center'>
								{' '}
								<p className='text-center text-[14px] font-medium leading-5 text-mudPurple'>
									This list is empty right now.
									<br /> Consider adding new courses...
								</p>{' '}
							</div>
						)}
						{!loading && courses.map(CourseButton)}
					</div>
				)}
				{mode === 'input' && <UploadForm setMode={setMode} closeModal={closeModal} />}
			</div>
		</ReactModal>
	);
}

export default ManageLanguageModal;

const UploadForm = ({ setMode, closeModal }: { setMode: any; closeModal: any }) => {
	const [processing, setProcessing] = useState(false);
	const navigate = useNavigate();
	const [hoveredButton, setHoveredButton] = useState(false);
	const [image, setImage] = useState<string | undefined>(undefined);
	const [selectedFile, setSelectedFile] = useState<any>(undefined);
	const [uploading, setUploading] = useState(false);
	const [errorText, setFileError] = useState('');

	const goBack = () => {
		setMode('list');
	};

	const pressUploadPicture = () => {
		if (!!selectedFile) return;
		document.getElementById('photo_upload_modal')?.click();
	};

	const closeImage = () => {
		setImage(undefined);
		setSelectedFile(undefined);
		setUploading(false);
	};

	const onImageChange = (e: any) => {
		if (!e.target.files || e.target.files.length === 0) {
			setSelectedFile(undefined);
			return;
		}
		setFileError('');
		let file = e.target.files[0];
		if (file.size > 15728640) {
			alert('File is to big.');
			setSelectedFile(undefined);
			return;
		}
		setSelectedFile(file);
	};
	const resetInputValue = (e: any) => {
		e.target.value = null;
	};

	const uploadFile = async () => {
		if (!selectedFile) return;
		setUploading(true);
		const resp = await uploadExelFile({ file: selectedFile });
		console.log('resp upload exel', resp);
		if (resp.status == 201) {
			notify('File is uploaded');
			setUploading(false);
			closeModal();
		} else {
			notify('File is not uploaded');
			setUploading(false);
			return;
		}
	};

	return (
		<div className='bg-white min-h-[426px] rounded-xl mx-3 flex-1 flex flex-col gap-5 px-[40px] py-[30px]'>
			<div className='flex flex-row items-center  gap-4'>
				<div
					className=' flex cursor-pointer items-center justify-center bg-primaryViolet hover:bg-darkViolet  min-w-[56px] w-[56px] h-[56px] rounded-full'
					onClick={() => goBack()}
					onMouseEnter={() => setHoveredButton(true)}
					onMouseLeave={() => setHoveredButton(false)}
				>
					<TargetUndo fill={hoveredButton ? '#FDDF6D' : '#FFFFFF'} />
				</div>
			</div>
			<div className='flex-1 min-h-[290px] rounded-[10px] bg-[#ECEBF8] p-[20px] custom-shadow flex flex-col'>
				<div
					className={`flex-1 bg-[#FFFFFF] rounded-[10px] flex items-center border-2 justify-center transition-all duration-300 ease-in-out flex-col text-[#BEBECE] font-semibold relative
                ${!!selectedFile ? 'border-[#BEBECE]' : 'pointer hover:border-[#BEBECE]  border-[#FFFFFF]'}
                `}
					onClick={pressUploadPicture}
				>
					<UploadDataIcon />
					<div className='mt-[5px]'>{selectedFile ? selectedFile?.name : 'Attach file'}</div>
					{selectedFile && (
						<button
							className='flex h-[30px] w-[30px] rounded-full bg-[#BEBECE] items-center justify-center transition-all duration-300 ease-in-out absolute top-3 right-3 hover:bg-[#413F5E]'
							onClick={closeImage}
						>
							<ExitCross style={{ fill: 'white' }} />
						</button>
					)}
				</div>
				<div className='flex flex-row  mt-[20px] items-center'>
					<div className='flex-1  flex flex-row justify-between mr-[20px]'>
						<span></span>
						<p className='text-redError font-semibold text-[16px]'>{errorText}</p>
					</div>
					<button
						className={`h-[50px] w-[280px] flex items-center justify-center rounded-full bg-primaryViolet text-[#FDDF6D] font-bold text-[16px] transition-all ease-in-out duration-[230ms] 
                    ${uploading ? '' : 'hover:bg-[#FDDF6D] hover:text-primaryViolet'}
                    `}
						onClick={uploadFile}
						disabled={uploading}
					>
						{uploading ? <Loading /> : 'Upload data'}
					</button>
				</div>
				<input
					title='Add Video/Photo'
					style={{ display: 'none' }}
					accept='.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
					type='file'
					id='photo_upload_modal'
					onChange={onImageChange}
					onClick={resetInputValue}
				/>
			</div>
		</div>
	);
};
